/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

export const changeGreetingStatusModelSchema = z.object({
    "isActive": z.boolean().describe("Участвует ли шаблон в расписании"),
"greetingIds": z.array(z.string().uuid()).describe("Идентификаторы приветственных экранов")
    })